import React from 'react';
import Colorpicker from '../Colorpicker/Colorpicker';
import ChartBuilderDataDetail from './ChartBuilderDataDetail';
import ChartBuilderChartGuidelines from './ChartBuilderChartGuidelines';

export default class ChartBuilderSecondaryAxisDetails extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="container">
        {this.renderLabelDetails()}
        {this.renderSecondaryDataDetails()}
        <ChartBuilderChartGuidelines {...this.props} />
      </div>
    );
  };

  renderLabelDetails(){
    return(
      <div>
        <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 15, paddingLeft: 0, marginBottom: 10 }}>{this.props.primaryAxisDetail.chart_element === 'x-axis' ? I18n.t('vertical_axis_details') : I18n.t('horizontal_axis_details')}</h5>
        <div className='row'>
          {this.renderSecondaryAxisLabel()}
          {/* {this.renderColorPallet()} */}
        </div>
      </div>
    );
  };

  renderSecondaryAxisLabel(){
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label>{`${I18n.t('label')}*`}</label>
          <input type="text" name={this.props.report_details.chart_type.primary_chart_element === 'x-axis' && !this.props.secondaryAxis2 ? 'y_label' : this.props.report_details.chart_type.primary_chart_element === 'x-axis' && this.props.secondaryAxis2 ? 'second_y_label' : 'x_label'} className={this.fieldErrors('Label') ? 'form-control has-errors' : 'form-control'} value={this.labelValue()} onChange={this.props.onChangeReportDetails} />
          {
            this.fieldErrors('Label')
              ?
              <div className="help-block">
                <ul>{I18n.t('cant_be_blank')}</ul>
              </div>
              :
              null
          }
        </div>
      </div>
    );
  };

  renderColorPallet(){
    var palettes = Object.keys(this.props.colorPalettes)
    return(
      <div className="col-md-2">
        <div className="form-group">
          <label>{`${I18n.t('palette')}`}</label>
          <div>
            <input
              type="radio"
              value={false}
              checked={this.props.activeColorPallet === 'none' ? true : false}
            />
            <div style={{ display: 'inline-block', marginLeft: '10px' }}>
              {I18n.t('none')}
            </div>
          </div>
          {
            palettes.map(cp => {
              return(
                <div key={cp}>
                  <input
                    type="radio"
                    value={cp}
                    checked={this.props.activeColorPallet === cp ? true : false}
                  />
                  <div style={{display:'inline-block', marginLeft:'10px'}}>
                  {
                    this.props.colorPalettes[cp].map(color => {
                      return <span key={color} style={{marginRight:'3px'}}><Colorpicker name={color} color={color} read_only={true} width={15} height={15} /></span>
                    })
                  }
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  renderSecondaryDataDetails(){
    return(
      [
        <div key="secondary-data-details" style={{height:'5rem'}}>
          <h5 key="secondary-axis-data-details-label" className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 15, paddingLeft: 0, marginTop: 10, marginBottom: 10 }}>{I18n.t('data_details')}</h5>
          <div key="add-button-wrapper" className="flexed content-right add-data-detail" style={{ marginBottom: 15 }}>
            <button key="add-button" name={this.props.report_details.chart_type.primary_chart_element === 'x-axis' && !this.props.secondaryAxis2 ? 'y-axis' : this.props.report_details.chart_type.primary_chart_element === 'x-axis' && this.props.secondaryAxis2 ? 'second-y-axis' : 'x-axis'} onClick={this.props.onAddSecondaryAxisDetail} type="button" className="btn btn-secondary btn-sm" ><span className="ss-plus">&nbsp;</span> {I18n.t('add')}</button>
          </div>
        </div>,
        this.renderDataDetails()
      ]
    );
  };

  renderDataDetails(){
    return (
      this.props.axisDataDetails.map((detail) => {
        return <ChartBuilderDataDetail key={detail.id} detail={detail} {...this.props} primaryAxisDetail={this.props.primaryAxisDetail} errors={this.props.secondaryAxisErrors && this.props.secondaryAxisErrors[detail.id] && this.props.secondaryAxisErrors[detail.id].length ? this.props.secondaryAxisErrors[detail.id] : []} onAddSegmentOn={this.props.onAddSegmentOn} removeSegmentOn={this.props.removeSegmentOn} />
      })
    );
  };

  fieldErrors(field) {
    var fieldError = false
    this.props.errors.forEach((error) => {
      if (error.includes(field)) {
        fieldError = true
      };
    });
    return fieldError
  };

  labelValue(){
    if (this.props.report_details.chart_type.name === 'horizontal_bar_chart' && this.props.report_details.x_label ){
      return this.props.report_details.x_label
    } else if (this.props.report_details.second_y_label && this.props.secondaryAxis2){
      return this.props.report_details.second_y_label
    } else if (this.props.report_details.y_label && !this.props.secondaryAxis2&& this.props.report_details.chart_type.name !== 'horizontal_bar_chart'){
      return this.props.report_details.y_label
    } else{
      return ''
    };
  };

};